var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 1.58334H6.33331C3.71369 1.58334 1.58331 3.71372 1.58331 6.33334V16.625C1.58331 16.835 1.66672 17.0363 1.81519 17.1848C1.96365 17.3333 2.16502 17.4167 2.37498 17.4167H12.6666C15.2863 17.4167 17.4166 15.2863 17.4166 12.6667V6.33334C17.4166 3.71372 15.2863 1.58334 12.6666 1.58334ZM15.8333 12.6667C15.8333 14.4131 14.4131 15.8333 12.6666 15.8333H3.16665V6.33334C3.16665 4.58693 4.5869 3.16668 6.33331 3.16668H12.6666C14.4131 3.16668 15.8333 4.58693 15.8333 6.33334V12.6667Z",
    fill: "#0A6934"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54169 11.8647V13.4472H7.12423L11.5014 9.07566L9.9196 7.49391L5.54169 11.8647ZM12.2471 8.32991L10.6654 6.74657L11.8711 5.54166L13.4544 7.1242L12.2471 8.32991Z",
    fill: "#0A6934"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.0cea2b7d0ea7aa64fac5fb30e7db3555.svg";
export { ForwardRef as ReactComponent };